var map = {
	"./WhatsApp Image 2025-01-27 at 2.08.47 PM.jpeg": 19915,
	"./WhatsApp Image 2025-01-27 at 2.08.48 PM (1).jpeg": 42986,
	"./WhatsApp Image 2025-01-27 at 2.08.48 PM (2).jpeg": 37749,
	"./WhatsApp Image 2025-01-27 at 2.08.48 PM.jpeg": 67184,
	"./WhatsApp Image 2025-01-27 at 2.08.49 PM.jpeg": 80733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30951;